import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-146e3302"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "com-title"
};
const _hoisted_2 = {
  class: "title-c"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "left"
}, null, -1));
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "more"
}, null, -1));
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'CommonTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: false
    },
    jumpPath: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    onMounted(() => {});
    const more = () => {
      if (!props.showMore) return;
      if (!props.jumpPath) return;
      router.push({
        path: '/' + props.jumpPath
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1), __props.showMore ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "right",
        onClick: more
      }, [_createTextVNode(" 更多"), _hoisted_5])) : _createCommentVNode("", true)])]);
    };
  }
};